import React from 'react';
import { StyledSwitch } from './switch.style';

export interface ISwitchProps {
  edge?: 'start' | 'end';
  checked: boolean;
  className?: string;
  onChange: (e: any) => void;
  disabled?: boolean;
  inputProps?: object;
  id?: string;
};

const Switch = (props: ISwitchProps) => {
  const { edge, checked, className, inputProps, onChange, disabled, id } = props;

  return (
    <>
      <StyledSwitch
        edge={edge}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        inputProps={inputProps}
        className={className}
        id={id}
      />
    </>
  )
};

export const defaultProps = {
  edge: 'start',
  checked: false,
  className: '',
  onChange: () => { },
  disabled: false,
  inputProps: {},
};

Switch.defaultProps = defaultProps;
Switch.displayName = 'Switch';

export default Switch;